// Module
var code = "<div class=\"pageable-list\">\n    <div ng-transclude></div>\n</div>";
// Exports
var _module_exports = code;;
var path = 'template/component/widget/pageable-list/pageable-list.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;